const ACCOUNT_ORIGINS = {
  CUSTOMER: 1,
  HOUSE: 2,
};

export default ACCOUNT_ORIGINS;
